function noop(): void {}

export default noop;
